import { integrationRecipes } from './integration-recipes.js';
document.querySelector('#integration-recipes').append(integrationRecipes());
